
/* Oct 16 (Jacob, meeting #60): Candy Cane landing page at /pages/candy-cane (view 'candycane').
   Pre-launch until the Shopify product is published and in stock: buttons read "Drops Nov 1" and a countdown runs.
   Once /products/candy-cane-limited-holiday-edition.js says available, buttons become add-to-cart (quickAdd). */
(function(){
  var DROP=Date.parse('2026-11-01T06:00:00Z'); /* Nov 1, 00:00 MT */
  var V=window.__VMAP=window.__VMAP||{};V.misc=V.misc||{};
  var M={'candy cane 5-pack':48107514364123,'candy cane 3-pack':47984090317019,'candy cane oil':48107514396891,'candy cane oil with pod topper':48975870296283,'candy cane refresh kit · black pod':48107514429659,'candy cane refresh kit · white pod':48107514462427};
  for(var k in M)V.misc[k]=M[k];
  var live=false,avail={},timer=null,snowOn=false;
  window.ccScrollShop=function(){var e=document.getElementById('cc-shop');if(e)e.scrollIntoView({behavior:'smooth'})};
  window.ccNotify=function(){try{(window._klOnsite=window._klOnsite||[]).push(['openForm','UL8Dad'])}catch(e){}};
  var MOMENTS=[
    ['The 4-hour drive to the in-laws.','Pop one in at the first gas station. <a href="#cc-shop" onclick="ccScrollShop();return false">Grab the 5-pack.</a>'],
    ['Wrapping gifts at 1am.','Tape, scissors, a cool hit of peppermint. <a href="#cc-shop" onclick="ccScrollShop();return false">The oil keeps it going.</a>'],
    ['The office white elephant.','Under $20, actually useful. <a href="#cc-shop" onclick="ccScrollShop();return false">Bring a 3-pack.</a>'],
    ['A middle seat on a 6am flight.','Your own little bubble of vanilla and mint. <a href="#cc-shop" onclick="ccScrollShop();return false">Pack the 3-pack.</a>'],
    ['The mall parking lot on December 23.','Deep breath. Peppermint helps. <a href="#cc-shop" onclick="ccScrollShop();return false">Get the 5-pack.</a>'],
    ['Your aunt\'s 14 scented candles.','Bring your own scent. <a href="#cc-shop" onclick="ccScrollShop();return false">Candy Cane, worn under your nose.</a>'],
    ['The cookie exchange you forgot about.','Show up smelling like you baked. <a href="#cc-shop" onclick="ccScrollShop();return false">Grab a 3-pack.</a>'],
    ['Row 19 at the holiday concert.','Two hours of recorders. You deserve this. <a href="#cc-shop" onclick="ccScrollShop();return false">The 5-pack.</a>'],
    ['A house full of family and opinions.','Step outside, breathe peppermint, step back in. <a href="#cc-shop" onclick="ccScrollShop();return false">The refresh kit.</a>'],
    ['The long walk to see the lights.','Cold air, warm vanilla, crisp mint. <a href="#cc-shop" onclick="ccScrollShop();return false">Start with the 5-pack.</a>']
  ];
  var spins=0,lastM=-1;
  window.ccSpin=function(){
    var s=document.querySelector('#view-candycane .cc-swirl-in'),box=document.querySelector('#view-candycane .cc-moment');if(!s||!box)return;
    spins+=1;var deg=spins*900+Math.floor(Math.random()*360);
    s.style.transform='rotate('+deg+'deg)';box.classList.add('pop');
    var i;do{i=Math.floor(Math.random()*MOMENTS.length)}while(i===lastM&&MOMENTS.length>1);lastM=i;
    setTimeout(function(){box.querySelector('.cc-moment-t').textContent=MOMENTS[i][0];box.querySelector('.cc-moment-s').innerHTML=MOMENTS[i][1];box.classList.remove('pop')},window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches?0:1100);
  };
  function pad(n){return (n<10?'0':'')+n}
  function tick(){
    var root=document.getElementById('view-candycane');if(!root)return;
    var c=root.querySelector('.cc-count'),ms=DROP-Date.now();
    if(live||ms<=0){c.hidden=true;return}
    c.hidden=false;var t=Math.floor(ms/1000);
    c.querySelector('[data-cc="d"]').textContent=pad(Math.floor(t/86400));
    c.querySelector('[data-cc="h"]').textContent=pad(Math.floor(t%86400/3600));
    c.querySelector('[data-cc="m"]').textContent=pad(Math.floor(t%3600/60));
    c.querySelector('[data-cc="s"]').textContent=pad(t%60);
  }
  function snow(){
    if(snowOn)return;var box=document.querySelector('#view-candycane .cc-snow');if(!box)return;snowOn=true;
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var n=window.innerWidth<700?10:18,html='';
    for(var i=0;i<n;i++){var sz=14+Math.round(Math.random()*12);html+='<span class="cc-mint" style="left:'+(Math.random()*100).toFixed(1)+'%;width:'+sz+'px;height:'+(sz*2)+'px;animation-duration:'+(9+Math.random()*10).toFixed(1)+'s;animation-delay:-'+(Math.random()*18).toFixed(1)+'s"></span>'}
    box.innerHTML=html;
  }
  function paint(){
    var root=document.getElementById('view-candycane');if(!root)return;
    root.querySelectorAll('.cc-add,.cc-add-link').forEach(function(b){
      var p=parseFloat(b.getAttribute('data-cc-price'));
      if(live){
        b.disabled=false;
        if(b.classList.contains('cc-add'))b.textContent='Add to cart · $'+p.toFixed(2);
        b.onclick=function(){
          var name=b.getAttribute('data-cc-name');
          if(name==='candy cane refresh kit'){var sel=b.parentNode.querySelector('.cc-pod');name+=' · '+((sel&&sel.value)||'black')+' pod'}
          if(typeof quickAdd==='function')quickAdd(name,p);
        };
      }else{
        b.disabled=true;if(b.classList.contains('cc-add'))b.textContent='Drops Nov 1';b.onclick=null;
      }
    });
    root.querySelectorAll('.cc-when').forEach(function(e){e.textContent=live?'here now':'drops Nov 1'});
    root.querySelectorAll('.cc-list-btn').forEach(function(e){e.hidden=live});
    root.querySelectorAll('.cc-shop-btn').forEach(function(e){e.textContent=live?'Shop Candy Cane':'See the drop'});
  }
  function check(){
    fetch('/products/candy-cane-limited-holiday-edition.js').then(function(r){return r.ok?r.json():null}).then(function(j){
      live=!!(j&&j.available);paint();tick();
    }).catch(function(){paint()});
  }
  var was=false;
  setInterval(function(){
    var on=window.current==='candycane';
    if(on&&!was){check();snow();tick();if(!timer)timer=setInterval(tick,1000)}
    if(!on&&was&&timer){clearInterval(timer);timer=null}
    was=on;
  },400);
})();
